import React, { Fragment, ReactElement } from 'react';
import { Box, Grid, Button, Paper, Typography } from '@material-ui/core';
import { withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import { LanguagesEnum } from '../../config/languages';
import { ModalIDs } from '../../redux/reducers/gl_modal_reducer/types';
import AddIcon from '@material-ui/icons/Add';
import useStyles from './styles';
import FloatingButton from '../../components/atoms/floating_button';
import { useDispatch } from 'react-redux';
import ModalActions from '../../redux/reducers/gl_modal_reducer/actions';
import GraphsLayout from './components/graphs_layout';
import AdminKPIs from './components/admin_kpis';
import TraderKPIs from './components/trader_kpis';
import SimpleMap from './components/simpleMap';
import { Translations } from './configuration';
import clsx from 'clsx';
import AdminDashboardActions from 'redux/reducers/admin_dashboard_reducer/actions';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';
import { useHistory } from 'react-router-dom';
import NavigationConfig from 'navigation/config';
import AuthActions from '../../redux/reducers/gl_auth_reducer/actions';

const Dashboard = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ROLE = AuthSelectors.useSelectUserRole();

  if (!ROLE) {
    dispatch(AuthActions.logoutAction(history));
  }

  const classes = useStyles();

  const query = useQuery();
  const schemeType = query.get('schemeType');
  const periodLength = query.get('periodLength');

  let searchParams = {
    ...(schemeType && { schemeType }),
    ...(periodLength && { periodLength }),
  };

  React.useEffect(() => {
    if (ROLE === AuthRoles.Admin) {
      dispatch(
        AdminDashboardActions.fetchAdminDashboardDataAction({
          ...searchParams,
        })
      );
    } else if (ROLE === AuthRoles.User) {
      dispatch(AdminDashboardActions.fetchTraderDashboardDataAction());
    }
  }, [dispatch, searchParams]);

  return (
    <Fragment>
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <div className={classes.header}>
          <Box display="flex" alignItems={'center'}>
            <Typography component={'p'} variant={'h6'}>
              <TranslatedText
                textMap={Translations.page_title}
                defaultText={Translations.page_title.English}
              />
            </Typography>
          </Box>
        </div>
      </Paper>
      {ROLE === AuthRoles.Admin && (
        <div style={{ padding: 12 }}>
          <div className={classes.cardLayout}>
            {/* <div className={classes.root}> */}
            {/* <GraphsLayout /> */}
            {/* </div> */}
            {ROLE === AuthRoles.Admin && <AdminKPIs />}
          </div>
        </div>
      )}
      <div style={{ padding: 12 }}>
        <div className={classes.cardLayout}>
          {/* <div className={classes.root}> */}
          {/* <GraphsLayout /> */}
          {/* </div> */}
          {ROLE === AuthRoles.User && <TraderKPIs />}
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(Dashboard);
